import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #fff;
  font-style: normal;
  line-height: normal;
  font-family: Roboto, sans-serif;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  color: rgba(0, 0, 0, 0.88);
`;

export const PageHeader = styled.div`
  flex-shrink: 0;
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 24px;
  letter-spacing: -0.48px;
  padding: 24px 16px 16px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  background: #fff;
  display: flex;
  justify-content: space-between;
`;

export const PageContent = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  overflow: hidden;
`;

export const LeftPanel = styled.div`
  padding: 20px 24px;
  flex-shrink: 0;
  border-right: 1px solid rgba(0, 0, 0, 0.15);
  overflow: scroll;
  @media screen and (max-width: 1280px) {
    width: 280px;
  }
  @media screen and (min-width: 1280px) {
    width: 280px;
  }
  @media screen and (min-width: 1440px) {
    width: 350px;
  }
  @media screen and (min-width: 1600px) {
    width: 350px;
  }
  @media screen and (min-width: 1920px) {
    width: 400px;
  }
`;

export const RightPanel = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const LeftPanelTitle = styled.div`
  color: #000;
  font-size: 18px;
  font-weight: 500;
`;

export const TopBar = styled.div`
  height: 61px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  flex-shrink: 0;
  color: rgba(0, 0, 0, 0.88);
  font-weight: 500;
  font-size: 18px;

  .active-item {
    color: rgba(0, 0, 0, 0.88);
    font-weight: 500;
    font-size: 18px;
    font-family: Roboto, sans-serif;

    &:hover {
      background-color: transparent;
      cursor: default;
    }
  }
  .inactive-item {
    color: #0046ff;
    font-weight: 500;
    font-size: 18px;
    font-family: Roboto, sans-serif;

    &:hover {
      background-color: transparent;
      color: #0046ff;
      cursor: pointer;
    }
  }
`;

export const MetricListItemWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const MetricListItemName = styled.div`
  display: flex;
  flex: 1;
  // resolve flex layout child element width exceeds parent element
  min-width: 0;
`;

export const Layout = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  background-color: white;
  flex-direction: column;
`;

export const TopPanel = styled.div`
  width: 100%;
  height: 52px;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  font-size: 16px;
  font-weight: 500;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  background: #f5f5f5;
`;

export const ContentWrapper = styled.div`
  width: 100%;
  overflow: scroll;
`;

export const MetricName = styled.div`
  font-weight: 400;
  display: flex;
  align-items: center;
  flex: 1;
  // resolve flex layout child element width exceeds parent element
  min-width: 0;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  // resolve flex layout child element width exceeds parent element
  min-width: 0;
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  & > *:not(:last-child) {
    margin-right: 32px; /* Reserve space for delimiters */
  }

  & > *:not(:last-child)::after {
    content: '';
    position: absolute;
    right: -17px; /* Adjust separator position */
    top: 0;
    bottom: 0;
    width: 1px;
    background-color: #d9d9d9;
    margin: 4px 0; /* Sets the upper and lower spacing of delimiters */
    pointer-events: none; /* Makes the pseudo-element not respond to mouse events */
  }
`;
